export interface CaptchaControlProps {
    onVerification: (verifyCaptchaResponse?: VerifyCaptchaResponse | undefined) => void;
    onCaptchaLoad?: (getCaptchaResponse?: GetCaptchaChallengeResponse | undefined) => void;
    baseUrl?: string;
}

export enum CaptchaChallengeType {
    Audio = 'audio',
    Visual = 'visual',
}

export interface GetCaptchaChallengeResponse {
    azureRegion: string;
    challengeId: string;
    content: string;
    contentType: string;
    correlationId: string;
    clientRequestId: string;
}

export interface GetCaptchaChallengeRequest {
    challengeType: CaptchaChallengeType;
    locale: string;
    correlationId?: string;
    clientRequestId?: string;
}

export interface VerifyCaptchaRequest {
    challengeId: string;
    solution: string;
    azureRegion: string;
    challengeType: CaptchaChallengeType;
    correlationId?: string;
    clientRequestId?: string;
}

export interface VerifyCaptchaResponse {
    solved: boolean;
    accessToken: VerifyCaptionToken;
    challengeId: string;
    reason: string;
}

interface VerifyCaptionToken {
    token: string;
    expiresOn: string;
}